var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnedIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91383 12.1027C5.44279 12.6073 4.6518 12.6346 4.14711 12.1636C2.91655 11.0047 1.71463 9.76606 0.788926 8.34665C0.384009 7.72578 -5.67782e-07 7.01042 -6.01032e-07 6.24976C-6.34281e-07 5.48909 0.384009 4.77373 0.788926 4.15286C1.70933 2.74158 2.92078 1.48316 4.14656 0.336452C4.65125 -0.13459 5.44279 -0.10783 5.91383 0.39686C6.3801 0.896435 6.34943 1.69862 5.85173 2.16467C4.921 3.042 4.02284 3.9779 3.2501 4.99976L17.2501 4.99976C18.7689 4.99976 20.0001 6.23097 20.0001 7.74975L20.0001 18.7498C20.0001 19.4401 19.4404 19.9998 18.7501 19.9998C18.0597 19.9998 17.5001 19.4401 17.5001 18.7498L17.5001 7.74976C17.5001 7.61168 17.3881 7.49976 17.2501 7.49976L3.2501 7.49976C4.0211 8.5193 4.91711 9.45296 5.84528 10.3288C6.34501 10.7974 6.38512 11.5977 5.91383 12.1027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnedIconRed);
export default __webpack_public_path__ + "static/media/returned-icon-red.2a5a382ce35e254b143eb1b6992428a1.svg";
export { ForwardRef as ReactComponent };